import { render, staticRenderFns } from "./LandscapeFeatureDescription.vue?vue&type=template&id=b1845618&scoped=true&"
import script from "./LandscapeFeatureDescription.vue?vue&type=script&lang=js&"
export * from "./LandscapeFeatureDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1845618",
  null
  
)

export default component.exports